import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/qa";

export const qaApi = {
  list: (params?: PaginatedParams & { tags?: string[] }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.sort) searchParams.set("sort", params.sort);
    if (params?.order) searchParams.set("order", params.order);
    if (params?.tags?.length) searchParams.set("tags", params.tags.join(","));
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ question: Record<string, unknown> }>(`${BASE}/${id}`),

  ask: (data: Record<string, unknown>) => apiPost<{ question: Record<string, unknown> }>(BASE, data),

  update: (id: string, data: Record<string, unknown>) =>
    apiPut<{ question: Record<string, unknown> }>(`${BASE}/${id}`, data),

  delete: (id: string) => apiDelete<{ message: string }>(`${BASE}/${id}`),

  addAnswer: (id: string, content: string) =>
    apiPost<{ answer: Record<string, unknown> }>(`${BASE}/${id}/answers`, { content }),

  acceptAnswer: (questionId: string, answerId: string) =>
    apiPost<{ question: Record<string, unknown> }>(`${BASE}/${questionId}/answers/${answerId}/accept`),

  upvote: (id: string) => apiPost<{ question: Record<string, unknown> }>(`${BASE}/${id}/upvote`),

  downvote: (id: string) => apiPost<{ question: Record<string, unknown> }>(`${BASE}/${id}/downvote`),
};
